const getStateIconSvg = (state: string, size: number = 200) => {
  const center = size / 2
  const radius = size * 0.4
  const strokeWidth = size * 0.04
  const fontSize = size * 0.24

  return `
  <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
    <rect 
      x="0" 
      y="0" 
      width="${size}" 
      height="${size}" 
      fill="transparent" 
      stroke="none"
    />
  
    <circle 
      cx="${center}" 
      cy="${center}" 
      r="${radius}" 
      fill="#4285f4" 
      fill-opacity="0.6"
      stroke="#1a73e8"
      stroke-width="${strokeWidth}"
      stroke-opacity="0.9"
    />
  
    <text 
      x="${center}" 
      y="${center + fontSize * 0.1}" 
      text-anchor="middle" 
      dominant-baseline="middle"
      fill="#ffffff" 
      font-family="Arial, sans-serif" 
      font-size="${fontSize}" 
      font-weight="bold"
    >
      ${state.toUpperCase()}
    </text>
  </svg>
  `
}

const getTooltipData = (object: any, layer: any) => {
  if (!object || layer?.id !== 'miles-by-state-icon-layer') return null

  const { state, miles } = object.properties || {}

  return {
    html: `<div style="padding: 12px; background: white; color: #333; border-radius: 8px; font-size: 14px; box-shadow: 0 2px 8px rgba(0,0,0,0.15); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; line-height: 1.4; max-width: 250px; word-wrap: break-word; overflow-wrap: break-word;">
               <div style="font-weight: 600; margin-bottom: 4px;">${
                 state || '-'
               } </div>
               <div style="margin-bottom: 4px;">${
                 miles.toLocaleString(undefined, {
                   maximumFractionDigits: 0,
                 }) || 0
               } miles</div>
             </div>`,
    style: {
      backgroundColor: 'transparent',
      fontSize: '14px',
    },
  }
}

const getIconSize = (percentage: number) => {
  const maxSize = 130
  const minSize = 10
  const range = maxSize - minSize
  const percentageAsDecimal = percentage / 100

  const size = minSize + range * percentageAsDecimal

  return Math.max(minSize, Math.min(size, maxSize))
}

export { getStateIconSvg, getTooltipData, getIconSize }
